<template>
  <router-link
    :to="{ name: 'TournamentSingle', params: { id: tournament.slug }}"
    :class="`${columnClass ? columnClass : 'col-12'}`"
  >
    <div :class="`tournament-card ${tournament.active ? 'active' : 'inactive'}`">
      <div class="card-header">
        <div class="background">
          <b-img :src="tournament.cover.url"/>
          <div class="bg-overlay">
            <figure class="tournament-badge">
              <b-img :src="tournament.badge.url"/>
            </figure>
          </div>
        </div>
      </div>
      <div class="card-content">
        <h4 v-html="tournament.name"></h4>
        <p v-if="tournament.starts_at">
          Início:
          <span v-html="tournament.starts_at"></span>
        </p>
        <p v-if="tournament.slots">
          Máximo de Times:
          <span v-html="tournament.slots"></span>
        </p>

        <p v-if="tournament.inscription_price">
          Inscrição:
          <span v-html="tournament.friendly_inscription_price"></span>
        </p>
        <p v-else>
          <strong>Gratuito</strong>
        </p>

        <!-- <p v-if="tournament.prize_price">
          Premiação 1o Lugar:
          <span v-html="tournament.friendly_prize_price"></span>
        </p>-->
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "TournamentCard",
  props: {
    tournament: Object,
    columnClass: String
  }
};
</script>

<style scoped lang="sass">
.tournament-card
  height: 400px
  margin-bottom: 20px
  
  position: relative
  overflow: hidden
  
  background: rgba(0, 0, 0, .2)
  border-radius: 4px
  
  transition: all .2s
  color: white

  opacity: .8

  &.inactive
    opacity: .3

  &:hover
    transform: scale(1.05)
    opacity: 1

  .card-header
    width: 100%
    height: 180px
    overflow: hidden
    position: absolute
    top: 0
    left: 0

    .background
      width: 100%
      height: 180px
      position: absolute
      display: flex
      top: 0
      left: 0
      img
        width: auto
        height: 100%
      .bg-overlay
        background: rgba(0, 0, 0, .8)
        z-index: 4
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        display: flex
        justify-content: center
        align-items: center
        .tournament-badge
          display: block
          img
            width: 128px
            height: 128px

        
  .card-content
    position: absolute
    top: 180px
    left: 0
    width: 100%
    height: 300px
    padding: 20px  
    h4
      // text-align: center
      // width: 100%
    p
      margin: 5px 0
      font-size: 12px
      span
        font-size: 14px
        text-transform: uppercase
</style>
